import { Search, SlidersHorizontal } from 'lucide-react';
import { Input } from '@/shared/components/ui/Input';
import { Select } from '@/shared/components/ui/Select';
import type { ProjectOption, UserOption } from '../types';

interface TasksFilterBarProps {
  search: string;
  projectId: string;
  assignedTo: string;
  isAdmin: boolean;
  projects: ProjectOption[];
  users: UserOption[];
  onSearchChange: (v: string) => void;
  onProjectChange: (v: string) => void;
  onAssignedToChange: (v: string) => void;
}

export function TasksFilterBar({
  search,
  projectId,
  assignedTo,
  isAdmin,
  projects,
  users,
  onSearchChange,
  onProjectChange,
  onAssignedToChange,
}: TasksFilterBarProps) {
  const projectOptions = [
    { value: '', label: 'All Projects' },
    ...projects.map((p) => ({ value: p.id, label: p.name })),
  ];

  const userOptions = [
    { value: '', label: 'All Assignees' },
    ...users.map((u) => ({ value: u.id, label: u.display_name })),
  ];

  return (
    <div className="flex flex-wrap items-center gap-3 rounded-card border border-outline bg-surface p-3">
      <SlidersHorizontal className="h-4 w-4 shrink-0 text-on-surface-variant" />

      {/* Search */}
      <div className="min-w-[220px] flex-1">
        <Input
          name="task-search"
          placeholder="Search tasks…"
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          leftIcon={<Search className="h-4 w-4" />}
        />
      </div>

      {/* Project filter */}
      <div className="w-44">
        <Select
          name="task-project-filter"
          options={projectOptions}
          value={projectId}
          onChange={(e) => onProjectChange(e.target.value)}
        />
      </div>

      {/* Assignee filter — admin/superadmin only */}
      {isAdmin && (
        <div className="w-44">
          <Select
            name="task-assignee-filter"
            options={userOptions}
            value={assignedTo}
            onChange={(e) => onAssignedToChange(e.target.value)}
          />
        </div>
      )}
    </div>
  );
}
